module.exports = "<h1 mat-dialog-title>{{data.header}}</h1>\n<div mat-dialog-content class=\"text--center\">\n  <div>\n    <p><strong>{{data.status}}</strong></p>\n    <p>{{data.message}}</p>\n  </div>\n</div>\n<div mat-dialog-actions>\n  <!--<button mat-button (click)=\"onNoClick()\">Okay</button>-->\n  <button mat-button [mat-dialog-close]=\"data\" cdkFocusInitial>Ok</button>\n</div>\n\n\n"


//////////////////
// WEBPACK FOOTER
// /Users/brianyoung/Documents/Development/hfg/datalive-core/gae-web/datalive/client/src/app/Dialogs/GeneralDialog/general-dialog.html
// module id = ../../../../../src/app/Dialogs/GeneralDialog/general-dialog.html
// module chunks = main